import FetchText from "@/@core/providers/fetch/fetchText";
const GET = "get";

/**
 * Text provider as in Text provided via HTTP (plain text / HTML requests)
 */
export default httpClient => {
  if (typeof httpClient === "string") {
    httpClient = new FetchText(httpClient);
  }

  return {
    [GET]: async path => httpClient.get(path),
  };
};
